import { render, staticRenderFns } from "./TypedepiecesShow.vue?vue&type=template&id=07bafd6a&"
import script from "./TypedepiecesShow.vue?vue&type=script&lang=js&"
export * from "./TypedepiecesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports